/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import * as actions from './action'
import Business from './component/business'

class ClubBusiness extends React.Component {
  static defaultProps = {
    paymentList: [],
    period: {
      start_time: moment().format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
    business: [],
    recordDetail: {
      list: [],
      goodsList: [],
    },
    serviceList: [],
    billRemarkList: [],
    billRemarkSumList: [],
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
    this.props.getBusiness([]) //清除
    this.props.getBillRemarks([]) //清除
    this.props.getPaymentList([]) //清除支付方式
  }

  render() {
    const { paymentList, period, business, recordDetail, serviceList,
      billRemarkList, billRemarkSumList } =
      this.props
    return (
      <Business
        paymentList={paymentList}
        period={period}
        business={business}
        recordDetail={recordDetail}
        serviceList={serviceList}
        billRemarkList={billRemarkList}
        billRemarkSumList={billRemarkSumList}
        fetchPaymentList={this.props.fetchPaymentList}
        fetchIncomeBusiness={this.props.fetchIncomeBusiness}
        fetchBillRemarks={this.props.fetchBillRemarks}
        exportBillRemarks={this.props.exportBillRemarks}
        getPeriod={this.props.getPeriod}
        fetchTimePeriod={this.props.fetchTimePeriod}
        fetchRecordDetails={this.props.fetchRecordDetails}
        fetchSnDetails={this.props.fetchSnDetails}
        incomeSumList={this.props.incomeSumList}
        getPurchaseServices={this.props.getPurchaseServices}
        settingsPurchases={this.props.settingsPurchases}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    paymentList: state.getClubBusiness.paymentList,
    period: state.getClubBusiness.period,
    business: state.getClubBusiness.business,
    recordDetail: state.getClubBusiness.recordDetail,
    incomeSumList: state.getClubBusiness.incomeSumList,
    serviceList: state.getClubBusiness.serviceList,
    billRemarkList: state.getClubBusiness.billRemarkList,
    billRemarkSumList: state.getClubBusiness.billRemarkSumList,
  }
}
export default withRouter(
  connect(mapStateToProps, {
    ...actions,
  })(ClubBusiness)
)



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/index.js